import React from "react"
import { graphql, Link } from "gatsby"
import Layout from "../components/layout"
import { isNullOrUndefined } from "util"

export default ({ data }) => {
  return (
    <Layout>
      <div>
        <h1>Sermons</h1>
        <ul>
          {data.allMarkdownRemark.edges.map(({ node }, index) => (
                <li key={index}>
                  <Link to={node.fields.slug}>{node.frontmatter.date} {node.frontmatter.title} by {node.frontmatter.author} {!isNullOrUndefined(node.frontmatter.scripture) && <span>about {node.frontmatter.scripture}</span>}</Link>
                </li>
          ))}
        </ul>
      </div>
    </Layout>
  )
}

export const query = graphql`
  {
    allMarkdownRemark(sort: {fields: frontmatter___date, order: DESC}, filter: {fields: {collection: {eq: "sermons"}}}) {
      edges {
        node {
          id
          fields {
            slug
          }
          html
          frontmatter {
            author
            title
            date(formatString: "MMMM Do YYYY")
            scripture
          }
        }
      }
      totalCount
    }
  }
`
